<script src="https://static.line-scdn.net/liff/edge/2/sdk.js"></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<template>
  <v-container>
    <v-layout text-center wrap>
      <span id="main_title">
        <span id="main_title_text">
          <h4>&emsp;</h4>
        </span>
      </span>
      <span id="header_logo"
        ><img src="https://misemeg.jp/appli/img/misemeg-logo.svg" width="49px"
      /></span>
      <!-- <span id="hamburger_menu" @click="preferences"><i class="fa fa-bars fa-3x fa-fw"></i></span>   -->
      <v-flex xs12>
        <!-- <h1>ようこそ！ {{ name }} <b>{{ email }}</b> {{ userId }}さん</h1> -->
        <!-- <h3><v-btn large color="error" @click="logout">ログアウト</v-btn></h3> -->
        <!-- <img src='https://misemeg.jp/owner/mb/assets/images/common/misemeg_icon.svg' height="100px" width="100px"> -->
        <!-- <h3>みせめぐ紹介ページ</h3> -->
      </v-flex>
      <br />
      <br />
      <v-flex mb-4 xs12>
        <div class="ma-4" id="top_button">
          <v-btn
            large
            color="success"
            @click="return2top"
            title="デジタル会員証を表示する"
            id="return2top_btn"
            >&emsp;デジタル会員証を表示する&emsp;</v-btn
          >
        </div>
      </v-flex>
      <br />
      <br />
      <v-flex mb-4 xs12>
        <div class="ma-4" id="migration_button" hidden>
          <v-btn
            large
            color="info"
            @click="migration"
            title="既存カード登録"
            class="migration_btn"
            >&emsp;既存カード情報を登録する&emsp;</v-btn
          >
        </div>
      </v-flex>
      <br />
      <br />
      <v-flex mb-4 xs12>
        <div class="ma-4" id="progress_ring">
          <!--  modal プログレスリング表示 modal-p   -->
          <div class="modal js-modal-p" style="margin-left: 0px">
            <div class="modal__bg js-modal-close"></div>
            <div class="modal__content_p">
              <div class="progress_ring">
                <br /><br />
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
                &ensp;データの登録中です&ensp;
                <br />
              </div>
            </div>
            <!--modal__inner-->
          </div>
          <!--modal__inner-->
          <span id="copyright"> </span>
          <!--modal modal-p -->
        </div>
        <!-- </v-flex> -->
        <br />
        <br />
        <span id="member_info" hidden></span>
        <span id="chg_digit_info" hidden></span>
        <!-- Snackbar -->
        <div>
          <v-snackbar
            v-model="snackbarFlag"
            color="primary"
            multi-line
            :timeout="snackbarTimeout"
            top
          >
            {{ snackbarText }}
          </v-snackbar>
        </div>
        <br />
        <br />
        <div class="ma-4">
          <br />
          <br />
          <span id="copyright"
            ><a
              href="https://www.busicom.co.jp/product/misemeg/mini/?openExternalBrowser=1"
              target="_blank"
              >&emsp;みせめぐ&nbsp;&times;&nbsp;LINEミニアプリ&emsp;<br />&emsp;Copyright
              &copy; BUSICOM.Co.,ltd. </a
            ><br />&emsp;v2.5.0.1&emsp;</span
          >
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
.v-main {
  background-color: #f3f3f3;
}
#main_title {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00843f;
  color: #ddd;
  width: 100%;
  height: 70px;
  letter-spacing: 0.3em;
  margin-top: -12px;
  margin-left: -12px;
  margin-right: -50px;
}
#main_title_text {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.3em;
  margin-top: 0px;
  margin-left: -10px;
  margin-right: 0px;
}
#main_column {
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  background-color: #00843f;
  color: #ddd;
  width: 90%;
}
#header_logo {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -70px;
  margin-left: 0px;
  margin-right: 100px;
}
#member_info_tbl {
  margin: 0 auto;
  color: navy;
}
#line_logout {
  margin: 0 auto;
}
#copyright {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}
#copyright a {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}
</style>
<script>
// for encrypt message
import crypto from "crypto-js";
var CryptoJS = require("crypto-js");
// var dts = new Date().getDate();
var dts = "651127";
var passPhrase =
  "45b54c392cc235a79ce573f623b2f8023" + dts + "d6dd6edf2488805962a3d223be6566b";
const salt = CryptoJS.lib.WordArray.random(128 / 8);
const iv = CryptoJS.lib.WordArray.random(128 / 8);
const key = "0921b90b3b7dab492b4aa897e3d0ccffde0f59579fc0c6229213c" + dts + "94822466ce8";

// for HTTP response
import axios from "axios";

export default {
  data() {
    return {
      snackbarFlag: false,
      snackbarTimeout: 3000,
      snackbarText: "",
      name: "",
      imgURL: "",
      userId: "",
      email: "",
      barcode_url: "",
      inClient: false,
    };
  },
  created() {
    // 最初にプログレスリングを6秒間表示して「デジタル会員証を表示する」ボタンと「既存カード移行」ボタンは非表示にする
    $("#progress_ring").show();
    $("#top_button").hide();
    $("#migration_button").hide();
    this.initializeLiff();
  },
  mounted() {
    $("#migration_button").hide();
    $("#main_title").css("width", window.outerWidth);
    window.setTimeout(() => {
      // プログレスリングを非表示にして「デジタル会員証を表示する」ボタンを表示する。
      // みせめぐに登録したユーザー情報の取得処理無内でuseridを取得できれば「既存カード移行」ボタンを表示する
      $("#progress_ring").hide();
      $("#top_button").show();
      if (liff.isLoggedIn()) {
        $("#main_title_text").html("登録完了");
      }
      // this.$router.push({ name: 'home' });
    }, 1000); // <-- 6sec timer
  },
  methods: {
    initializeLiff: function () {
      var me = this;
      liff.init(
        {
          liffId: process.env.VUE_APP_LIFF_ID,
        },
        (data) => {},
        (err) => {
          console.log("LIFF initialization failed", err);
        }
      );
    },
    logout: function () {
      // ログアウト
      if (liff.isLoggedIn()) {
        liff.logout();
        this.$router.push({ name: "home" });
      }
    },
    return2top: function () {
      // デジタル会員証表示ボタン（＝TOP画面に戻る）
      this.$router.push({ name: "home" });
    },
    /**
     * 既存カードの移行登録 migration
     * 0015155:【みせめぐ】LINEミニアプリに「会員カード移行」機能を移植する
     */
    migration: async function () {
      //移行処理専用画面
      // md5ライブラリの読み込み
      var md5 = require("md5");
      // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく
      var dt = new Date();
      var year = dt.getFullYear();
      var month = dt.getMonth() + 1;
      var strMonth = "";
      if (month < 10) {
        strMonth = "0" + month;
      } else {
        strMonth = month.toString();
      }
      var date = dt.getDate();
      var strDate = "";
      if (date < 10) {
        strDate = "0" + date;
      } else {
        strDate = date.toString();
      }
      var mmddyyyy = strMonth + "-" + strDate + "-" + year;

      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid = this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      var debug_mode = this.$_debug_mode();
      if (debug_mode == "2") {
        miseid = this.$_shopid();
      }
      // 引数１．mail address
      const idToken = await liff.getDecodedIDToken();
      console.log(idToken.email); // print decoded idToken object
      //メルアドが取得できれば表示、取得エラーの場合は入力を促す
      var email = idToken.email;
      try {
        if (email == "undefined" || email == null || email == "") {
          var encrypted_mail = localStorage.getItem("lmmini_" + dts + "_maddr");
          var dec_email = CryptoJS.AES.decrypt(encrypted_mail, key, { iv: iv });
          email = dec_email.toString(CryptoJS.enc.Utf8);
        }
      } catch (Exception) {
        email = "";
      }

      //----------------------------------------------------------
      // みせめぐに登録したユーザー情報の取得処理
      //（会員証は無いがみせめぐに登録したユーザー情報はある前提で
      // 既存カード移行画面に遷移する際に必要なuseridを取得する）
      //----------------------------------------------------------
      var codeinfo_url = "";
      //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にsv1/sv2固定にする
      var i_shopid = Number(this.$_shopid());
      if (debug_mode == "0") {
        codeinfo_url = this.$_debug_url();
      } else if (debug_mode == "2") {
        if (i_shopid % 2 == 0) {
          codeinfo_url = "https://sv2.misemeg.jp/";
        } else {
          codeinfo_url = "https://sv1.misemeg.jp/";
        }
      } else {
        if (i_shopid % 2 == 0) {
          codeinfo_url = "https://sv2.misemegu.jp/";
        } else {
          codeinfo_url = "https://sv1.misemegu.jp/";
        }
      }
      codeinfo_url += "appli/line/";
      codeinfo_url += "getMembershipCodeInfoHTML.php?mail=";
      codeinfo_url += email;
      codeinfo_url += "&shopid=";
      codeinfo_url += miseid;
      codeinfo_url +=
        "&security=" +
        md5(
          email +
            "5ca968c5c9c793ad75b49ac19b493ad2misemeg" +
            email +
            "!Busicom04510" +
            mmddyyyy
        );
      // window.alert('getMemInf = ' + codeinfo_url);
      await axios
        .get(codeinfo_url)
        //.then((response) => this.users = response.data)
        // .then((response) => document.getElementById('member_info').innerHTML = response.data)
        .then((response) => ($("#member_info").val = response.data))
        .catch((error) => console.log(error));

      // 引数２．userid
      var userid = $("#c_userid").val();

      // 引数３．shopid
      var shopid = miseid;

      // 引数４．svr（接続先サーバー　svr=1はSTG , svr=2は本番運用 ※main.jsのdebug_mode定義に揃えた）
      // 0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
      var svr = "&svr=1";
      var i_shopid = Number(this.$_shopid());
      if (debug_mode == "1") {
        svr = "&svr=1";
        if (i_shopid % 2 == 0) {
          svr = "&svr=4";
        } else {
          svr = "&svr=3";
        }
      } else {
        svr = "&svr=2";
        if (i_shopid % 2 == 0) {
          svr = "&svr=6";
        } else {
          svr = "&svr=5";
        }
      }
      var fqdn = "https://test.misemegu.jp/";
      //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
      var i_shopid = Number(this.$_shopid());
      if (debug_mode == "0") {
        fqdn = this.$_debug_url();
      } else if (debug_mode == "2") {
        fqdn = his.$_operation_url();
        if (i_shopid % 2 == 0) {
          fqdn = "https://sv2.misemeg.jp/";
        } else {
          fqdn = "https://sv1.misemeg.jp/";
        }
      } else {
        fqdn = this.$_test_url();
        if (i_shopid % 2 == 0) {
          fqdn = "https://sv2.misemegu.jp/";
        } else {
          fqdn = "https://sv1.misemegu.jp/";
        }
      }
      fqdn += "appli/line/relation/";
      // 引数５．chg_digit（桁数変更情報）
      var chg_digit = $("#chg_digit_info").val();
      // URL生成
      // （サンプル）window.location.href="https://test.misemegu.jp/appli/line/migrationUser.php?mail=YmNpaWppbWFAZ21haWwuY29t&uid=dTA0MDA5MzQ=&sid=NjUxMTI3";
      // var s_url =  fqdn + "appli/line/migrationUser.php?" + "&mail=" + btoa(email) + "&uid=" + btoa(userid) + "&sid=" + btoa(shopid)  + "&cdig=" + chg_digit + svr;
      var s_url =
        fqdn +
        "MCMigration.html?" +
        "&mail=" +
        btoa(email) +
        "&uid=" +
        btoa(userid) +
        "&sid=" +
        btoa(shopid) +
        "&cdig=" +
        chg_digit +
        svr;
      // 別ウィンドウで開く
      // window.alert(s_url);
      window.open(s_url, "_blank");
    },
    showSnackbar(text) {
      this.snackbarFlag = true;
      this.snackbarText = text;
      setTimeout(() => {
        this.snackbarFlag = false;
        this.snackbarText = "";
      }, this.snackbarTimeout);
    },
  },
};
</script>
